var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingProvisionalOffer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49827_64817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9375 1H60.6797L78.8438 19.1641V72.9688C78.8438 76.2997 76.1435 79 72.8125 79H25.9375C22.6065 79 19.9062 76.2997 19.9062 72.9688V7.03125C19.9062 3.70025 22.6065 1 25.9375 1Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0938 2V18.4062C60.0938 19.7006 61.1431 20.75 62.4375 20.75H78.8438L60.0938 2Z",
    fill: "#49D8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66 40H32.34C31.0477 40 30 39.5523 30 39C30 38.4477 31.0477 38 32.34 38H66.66C67.9523 38 69 38.4477 69 39C69 39.5523 67.9523 40 66.66 40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66 30H32.34C31.0477 30 30 29.5523 30 29C30 28.4477 31.0477 28 32.34 28H66.66C67.9523 28 69 28.4477 69 29C69 29.5523 67.9523 30 66.66 30Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66 51H32.34C31.0477 51 30 50.5523 30 50C30 49.4477 31.0477 49 32.34 49H66.66C67.9523 49 69 49.4477 69 50C69 50.5523 67.9523 51 66.66 51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.66 62H32.34C31.0477 62 30 61.5523 30 61C30 60.4477 31.0477 60 32.34 60H66.66C67.9523 60 69 60.4477 69 61C69 61.5523 67.9523 62 66.66 62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 80C9.61891 80 0.15625 70.5373 0.15625 58.9062C0.15625 47.2752 9.61891 37.8125 21.25 37.8125C32.8811 37.8125 42.3438 47.2752 42.3438 58.9062C42.3438 70.5373 32.8811 80 21.25 80Z",
    fill: "#FF7350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 37.8125V80C32.8811 80 42.3438 70.5373 42.3438 58.9062C42.3438 47.2752 32.8811 37.8125 21.25 37.8125Z",
    fill: "#FF4B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 42.5C12.2036 42.5 4.84375 49.8598 4.84375 58.9062C4.84375 67.9527 12.2036 75.3125 21.25 75.3125C30.2964 75.3125 37.6562 67.9527 37.6562 58.9062C37.6562 49.8598 30.2964 42.5 21.25 42.5Z",
    fill: "#E5E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 56.5625H23.5938V49.5312C23.5938 48.2369 22.5444 47.1875 21.25 47.1875C19.9556 47.1875 18.9062 48.2369 18.9062 49.5312V58.9062C18.9062 60.2006 19.9556 61.25 21.25 61.25H27.5C28.7944 61.25 29.8438 60.2006 29.8438 58.9062C29.8438 57.6119 28.7944 56.5625 27.5 56.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 56.5625H23.5938V49.5312C23.5938 48.2369 22.5444 47.1875 21.25 47.1875V61.25H27.5C28.7944 61.25 29.8438 60.2006 29.8438 58.9062C29.8438 57.6119 28.7944 56.5625 27.5 56.5625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49827_64817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingProvisionalOffer);
export default __webpack_public_path__ + "static/media/pending_provisional_offer.555cb93f5391378721114f1d891e6122.svg";
export { ForwardRef as ReactComponent };